import { render } from "./TypesettingButton.vue?vue&type=template&id=5792b1d6"
import script from "./TypesettingButton.vue?vue&type=script&lang=ts"
export * from "./TypesettingButton.vue?vue&type=script&lang=ts"

import "./TypesettingButton.vue?vue&type=style&index=0&id=5792b1d6&lang=less"
script.render = render

export default script